import { firestore, firebase } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getSuggestionKey from '../utilities/Data/Kit/getSuggestionKey'

const setKitSuggestion = async ({ kitSuggestion }) => {
	try {
		const kitSuggestions = Array.isArray(kitSuggestion) ? kitSuggestion : [kitSuggestion]
		const { uid, kitId, userName } = kitSuggestions[0]
		const ref = firestore.collection('kits').doc(kitId).collection('suggestions').doc(uid)
		return await ref.set({
			uid,
			userName,
			items: kitSuggestions.reduce((acc, ks) => {
				acc[getSuggestionKey(ks)] = { ...ks, createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(), modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp() }
				return acc
			}, {})
		}, { merge: true })
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default setKitSuggestion



// WEBPACK FOOTER //
// ./src/dataservices/setKitSuggestion.js